import retry from 'async-retry';
import { SegmentsSequence } from 'libs/core/src/domain';
import { Timestamp } from 'libs/core/src/types';
import { IPlayerDataProvider } from '../types';
import { ISegmentsApi } from '../types/ISegmentsApi';

/**
 * API-based implementation of IPlayerDataProvider.
 * Fetches segment data from a segments API implementation.
 */
export class ApiPlayerDataProvider implements IPlayerDataProvider {
  private static readonly MAX_RETRIES = 3;

  constructor(
    readonly stationId: string,
    private apiImpl: ISegmentsApi,
  ) {}

  fetchSegmentAudio(segmentId: number): Promise<Buffer> {
    return retry(async () => this.apiImpl.fetchSegmentAudio(this.stationId, segmentId), {
      retries: ApiPlayerDataProvider.MAX_RETRIES,
      minTimeout: 1000,
      maxTimeout: 1000,
      onRetry: (error: Error, attempt: number) => {
        console.warn(
          `Failed to fetch segment audio for segment ${segmentId} (attempt ${attempt}/${ApiPlayerDataProvider.MAX_RETRIES + 1}):`,
          error.message,
        );
      },
    });
  }

  fetchSequence(timestamp: Timestamp): Promise<SegmentsSequence> {
    return retry(async () => this.apiImpl.fetchSequence(this.stationId, timestamp), {
      retries: ApiPlayerDataProvider.MAX_RETRIES,
      minTimeout: 1000,
      maxTimeout: 1000,
      onRetry: (error: Error, attempt: number) => {
        console.warn(
          `Failed to fetch sequence for timestamp ${timestamp} (attempt ${attempt}/${ApiPlayerDataProvider.MAX_RETRIES + 1}):`,
          error.message,
        );
      },
    });
  }

  generateAudioURL(segmentId: number): string {
    return this.apiImpl.generateAudioURL(this.stationId, segmentId);
  }
}
